/**
 * Created by valerasiestov on 23.11.15.
 */


if (!window.module) {
    window.module = {};
}

module.selection = (function () {
    "use strict";

    var controls = {},
        handlers = {
            equipmentChange: function () {
                var url = this.getAttribute('data-change');

                if (parseInt(this.value) === -1) {
                    controls.templateWrap.classList.add('disabled');
                    return;
                }

                fetch(url + this.value)
                    .then(function (response) {
                        return response.text();
                    }).then(function (template) {
                        controls.changeable.innerHTML = template;
                        module.select.add({
                            element: controls.changeable.querySelectorAll('select')
                        });
                        controls.templateWrap.classList.remove('disabled');
                    })
            },

            someSelectChange: function (event) {
                var element = event.target;

                if (element.hasAttribute('data-change')) {
                    fetch(
                        element.getAttribute('data-change') + '?' +
                        element.getAttribute('name') + '=' + element.value)
                        .then(function (response) {
                            return response.json();
                        })
                        .then(function (json) {
                            handlers.applySelectData(json);
                        });
                }
            },

            applySelectData: function (data) {
                var wrap = controls.templateWrap,
                    temp,
                    option,
                    item,
                    count,
                    list,
                    i,
                    fragment;

                for (item in data) {

                    if (data.hasOwnProperty(item)) {
                        temp = wrap.querySelector('#' + item);

                        if (!temp) {
                            continue;
                        }

                        list = data[item];
                        count = list.length;
                        fragment = document.createDocumentFragment();

                        for (i = 0; i < count; i++) {
                            option = document.createElement('option');
                            option.value = list[i].id;
                            option.innerHTML = list[i].value;
                            fragment.appendChild(option);
                        }

                        temp.innerHTML = '';
                        temp.appendChild(fragment);

                        temp.customObject.render();
                    }

                }
            }
        };

    function setEventList() {
        controls.equipment.addEventListener('change', handlers.equipmentChange, false);
        controls.templateWrap.addEventListener('change', handlers.someSelectChange, false);
    }

    function getControls(params) {
        controls.params = params;
        controls.equipment = params.object.querySelector('#input-type-equipment');
        controls.templateWrap = params.object.querySelector('.popup__template-data');
        controls.changeable = controls.templateWrap.querySelector('.popup__template-changeable')
    }

    function init(params) {
        getControls(params);
        setEventList();
    }

    function destroy() {
        var temp;

        if (controls.equipment) {
            controls.equipment.removeEventListener('change', handlers.equipmentChange, false);
        }

        if (controls.templateWrap) {
            controls.templateWrap.removeEventListener('change', handlers.someSelectChange, false);
        }

        for (temp in controls) {

            if (controls.hasOwnProperty(temp)) {
                delete controls[temp];
            }

        }

    }

    return {
        init: init,
        destroy: destroy
    };

}());

